import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';

import {OphChipButtonComponent} from '../../shared/design/oph-chip-button/oph-chip-button.component';
import {UserHasRoleOptionDirective} from '../../shared/directives/user-has-role-option.directive';
import {RolePermissionOptions} from './../../core/model/role';

@Component({
  selector: 'projects-sked-selector',
  standalone: true,
  imports: [MatIconModule, OphChipButtonComponent, UserHasRoleOptionDirective],
  templateUrl: './projects-sked-selector.component.html',
  styleUrl: './projects-sked-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsSkedSelectorComponent {
  @Input() skeds: string[];
  @Input() loading: boolean;

  @Output() addSked = new EventEmitter();
  rolePermissionOptions = RolePermissionOptions;
}
